import * as api from '../api';
import { bazaarVoiceUserTokenRequest } from '../api/requestCreator';
import { safelyAccessNestedProperties } from '../utils';

// TODO: move to write a review click handler
// there is no corresponding reducer
// this does not need to be an action

const fetchWriteAReviewModalDetail = (omsId: string) => (
  dispatch: Function
) => {
  dispatch({
    type: 'WRITE_A_REVIEW',
    id: omsId,
  });

  const bazaarVoiceUserToken = bazaarVoiceUserTokenRequest();
  const { url, headers } = bazaarVoiceUserToken;

  api.getRequest(url, headers, true).then(
    (response: Object) => {
      const reviewerId = safelyAccessNestedProperties(
        ['data', 'reviewerInfoResponse', 'reviewerId'],
        response
      );
      if (reviewerId) {
        window.$BV.configure('global', {
          userToken: reviewerId,
          campaignId: 'myAccount',
        });
        window.$BV.ui('rr', 'submit_review', { productId: omsId });
      }
    },
    (error: Object) => {
      console.log(error);
    }
  );
};

export default fetchWriteAReviewModalDetail;
